export default "__VITE_ASSET__DIuyul_B__"